import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "../i18n/LanguageContext";
import { initAnalytics } from "../lib/analytics";
import Header from "./Header";
import Hero from "./Hero";
import TextMarqueeBand from "./TextMarqueeBand";
import About from "./About";
import Services from "./Services";
import Sports from "./Sports";
import Work from "./Work";
import Clients from "./Clients";
import Contact from "./Contact";
import Footer from "./Footer";
import ContactModal from "./ContactModal";

export default function Portfolio() {
  useEffect(() => {
    initAnalytics();
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div data-testid="portfolio-root" className="relative bg-[#0a0a0a] text-[#fafafa]">
        <Header />
        <main>
          <Hero />
          <TextMarqueeBand />
          <About />
          <Services />
          <Sports />
          <Work />
          <Clients />
          <Contact />
        </main>
        <Footer />
        <ContactModal />
      </div>
    </LanguageProvider>
  );
}
